import { render, staticRenderFns } from "./ColumnCreateModal.vue?vue&type=template&id=f17634a4&scoped=true&"
import script from "./ColumnCreateModal.vue?vue&type=script&lang=js&"
export * from "./ColumnCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./ColumnCreateModal.vue?vue&type=style&index=0&id=f17634a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17634a4",
  null
  
)

export default component.exports